/* Kreovo – PDP: galeria, wybór wariantu, dodanie do koszyka, pasek dolny */
(function () {
  'use strict';

  function fmtMoney(cents, format) {
    var f = format || '{{amount_with_comma_separator}} zł';
    var v = (cents / 100);
    var withComma = v.toFixed(2).replace('.', ',');
    var noDec = Math.round(v).toString();
    var amount = (cents % 100 === 0) ? noDec : withComma;
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  function initGallery(root) {
    var track = root.querySelector('[data-kr-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = root.querySelectorAll('[data-kr-dots] button');
    var thumbs = root.querySelectorAll('[data-kr-thumbs] button');
    var current = 0;
    function mark(i) {
      current = i;
      [dots, thumbs].forEach(function (list) {
        Array.prototype.forEach.call(list, function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      });
    }
    function go(i, smooth) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) mark(Math.min(i, slides.length - 1));
      }, 60);
    }, { passive: true });
    Array.prototype.forEach.call(dots, function (b, i) { b.addEventListener('click', function () { go(i); }); });
    Array.prototype.forEach.call(thumbs, function (b, i) { b.addEventListener('click', function () { go(i); }); });
    var prev = root.querySelector('[data-kr-prev]');
    var next = root.querySelector('[data-kr-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    root.krGo = function (mediaId) {
      for (var k = 0; k < slides.length; k++) {
        if (String(slides[k].getAttribute('data-media-id')) === String(mediaId)) { go(k); return; }
      }
    };
  }

  function initPdp(root) {
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-kr-variants]').textContent); } catch (e) {}
    var moneyFormat;
    try { moneyFormat = JSON.parse(root.querySelector('[data-kr-money]').textContent); } catch (e) {}
    var gal = root.querySelector('[data-kr-gal]');
    if (gal) initGallery(gal);

    var sel = { 1: null, 2: null, 3: null };
    root.querySelectorAll('[data-kr-opt]').forEach(function (b) {
      if (b.getAttribute('aria-checked') === 'true') sel[b.getAttribute('data-kr-opt')] = b.getAttribute('data-value');
    });

    var atc = root.querySelector('[data-kr-atc]');
    var atcLabel = root.querySelector('[data-kr-atc-label]');
    var baseLabel = atcLabel ? atcLabel.textContent.trim() : 'Dodaj do koszyka';
    var errBox = root.querySelector('[data-kr-err]');
    var sizeErr = root.querySelector('[data-kr-size-err]');
    var stickySet = root.querySelector('[data-kr-sticky-set]');
    var stickyPrice = root.querySelector('[data-kr-sticky-price]');

    function priceFor(o1, o2) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].o1 === o1 && (!o2 || variants[i].o2 === o2)) return variants[i].price;
      }
      return null;
    }
    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.o1 === sel[1] && v.o2 === sel[2] && v.o3 === sel[3]) return v;
      }
      return null;
    }
    function refresh() {
      var p = priceFor(sel[1], sel[2]);
      var txt = p !== null ? baseLabel + ' · ' + fmtMoney(p, moneyFormat) : baseLabel;
      if (atcLabel) atcLabel.textContent = txt;
      if (stickySet) stickySet.textContent = sel[1] || '';
      if (stickyPrice && p !== null) stickyPrice.textContent = fmtMoney(p, moneyFormat);
      var v2 = root.querySelector('[data-kr-val="2"]');
      if (v2) v2.textContent = sel[2] || '';
    }

    root.querySelectorAll('[data-kr-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var g = b.getAttribute('data-kr-opt');
        sel[g] = b.getAttribute('data-value');
        root.querySelectorAll('[data-kr-opt="' + g + '"]').forEach(function (o) { o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
        if (g === '3' && sizeErr) sizeErr.classList.remove('is-on');
        if (g === '2' && gal && gal.krGo) {
          for (var i = 0; i < variants.length; i++) { if (variants[i].o2 === sel[2] && variants[i].media) { gal.krGo(variants[i].media); break; } }
        }
        refresh();
      });
      b.addEventListener('keydown', function (e) {
        if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) < 0) return;
        e.preventDefault();
        var g = b.getAttribute('data-kr-opt');
        var list = Array.prototype.slice.call(root.querySelectorAll('[data-kr-opt="' + g + '"]'));
        var i = list.indexOf(b) + ((e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1);
        var n = list[(i + list.length) % list.length];
        n.focus(); n.click();
      });
    });

    function showErr(msg) {
      if (!errBox) return;
      errBox.textContent = msg; errBox.classList.add('is-on');
    }

    function sectionIds() {
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) { if (el.dataset && el.dataset.sectionId) ids.push(el.dataset.sectionId); });
      return ids;
    }

    async function addToCart() {
      if (errBox) errBox.classList.remove('is-on');
      if (!sel[3]) {
        if (sizeErr) sizeErr.classList.add('is-on');
        var grp = root.querySelector('[data-kr-group="3"]');
        if (grp) grp.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var v = findVariant();
      if (!v) { showErr('Ten wariant jest niedostępny. Wybierz inny kolor lub rozmiar.'); return; }
      if (!v.available) { showErr('Ten wariant jest chwilowo niedostępny.'); return; }
      atc.setAttribute('disabled', '');
      var ids = sectionIds();
      var Ev = null;
      try { Ev = (await import('@shopify/events')).CartLinesUpdateEvent; } catch (e) { Ev = null; }
      var deferred = Ev && Ev.createPromise ? Ev.createPromise() : null;
      if (Ev && deferred) {
        try {
          root.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: [{ merchandiseId: String(v.id), quantity: 1 }], promise: deferred.promise }));
        } catch (e) { deferred = null; }
      }
      try {
        var body = { items: [{ id: v.id, quantity: 1 }] };
        if (ids.length) body.sections = ids.join(',');
        var res = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        });
        var data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Nie udało się dodać do koszyka.');
        var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        var drawer = document.querySelector('theme-drawer#cart-drawer');
        if (deferred && Ev && Ev.createCartFromAjaxResponse && drawer) {
          deferred.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'kreovo-pdp', sourceId: root.id, itemCount: 1, sections: data.sections, didError: false } });
          setTimeout(function () {
            if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
            atc.removeAttribute('disabled');
          }, 350);
        } else {
          window.location.href = '/cart';
        }
      } catch (err) {
        if (deferred) { try { deferred.reject(err); } catch (e) {} }
        atc.removeAttribute('disabled');
        showErr(err && err.message ? err.message : 'Nie udało się dodać do koszyka. Spróbuj ponownie.');
      }
    }
    if (atc) atc.addEventListener('click', addToCart);

    // Tabela rozmiarów
    var dlg = root.querySelector('[data-kr-size-dlg]');
    root.querySelectorAll('[data-kr-open-size]').forEach(function (b) {
      b.addEventListener('click', function () { if (dlg && dlg.showModal) dlg.showModal(); });
    });
    if (dlg) {
      dlg.querySelectorAll('[data-kr-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }

    // Pasek dolny
    var sticky = root.querySelector('[data-kr-sticky]');
    var sbtn = root.querySelector('[data-kr-sticky-btn]');
    var buy = root.querySelector('.kr-buy');
    if (sticky && buy && 'IntersectionObserver' in window) {
      var past = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          past = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', past);
          sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
          if (sbtn) sbtn.tabIndex = past ? 0 : -1;
        });
      });
      io.observe(buy);
    }
    if (sbtn) sbtn.addEventListener('click', function () {
      var info = root.querySelector('#kr-buy') || root;
      if (!sel[3]) {
        var grp = root.querySelector('[data-kr-group="3"]');
        if (sizeErr) sizeErr.classList.add('is-on');
        (grp || info).scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      addToCart();
    });

    refresh();
  }

  function boot() {
    document.querySelectorAll('[data-kr-pdp]').forEach(function (r) { if (!r.krInit) { r.krInit = true; initPdp(r); } });
    document.querySelectorAll('[data-kr-scroll]').forEach(function (a) {
      if (a.krInit) return; a.krInit = true;
      a.addEventListener('click', function (e) {
        var t = document.querySelector('#kr-buy');
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
